import { Box, Text, ScrollArea, Button, Group, Paper, CopyButton, ActionIcon, Tooltip } from '@mantine/core';
import { IconDownload, IconCopy, IconCheck } from '@tabler/icons-react';
import { useAgentStore } from '@/stores/agentStore';

export const SummaryPanel = () => {
  const summary = useAgentStore((state) => state.summary);

  const handleDownload = () => {
    if (!summary) return;

    const blob = new Blob([summary.summary], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `resumo-reuniao-${new Date().toISOString().split('T')[0]}.md`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  if (!summary) {
    return (
      <Box p="md">
        <Text c="dimmed" ta="center" size="sm">
          O resumo sera gerado ao final da reuniao.
        </Text>
        <Text c="dimmed" ta="center" size="xs" mt="xs">
          Clique em "Encerrar Reuniao" para gerar o resumo.
        </Text>
      </Box>
    );
  }

  return (
    <Box p="md" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Group justify="space-between" mb="md">
        <Box>
          <Text fw={500}>Resumo da Reuniao</Text>
          <Text size="xs" c="dimmed">
            Gerado em{' '}
            {new Date(summary.generated_at).toLocaleString('pt-BR', {
              dateStyle: 'short',
              timeStyle: 'short',
            })}
          </Text>
        </Box>
        <Group gap="xs">
          <CopyButton value={summary.summary}>
            {({ copied, copy }) => (
              <Tooltip label={copied ? 'Copiado!' : 'Copiar'}>
                <ActionIcon color={copied ? 'green' : 'gray'} variant="subtle" onClick={copy}>
                  {copied ? <IconCheck size={16} /> : <IconCopy size={16} />}
                </ActionIcon>
              </Tooltip>
            )}
          </CopyButton>
          <Button
            size="xs"
            variant="light"
            leftSection={<IconDownload size={14} />}
            onClick={handleDownload}
          >
            Baixar MD
          </Button>
        </Group>
      </Group>

      {/* Content */}
      <ScrollArea style={{ flex: 1, minHeight: 0 }}>
        <Paper p="md" withBorder style={{ backgroundColor: 'var(--mantine-color-gray-0)' }}>
          <Box
            style={{
              whiteSpace: 'pre-wrap',
              fontFamily: 'var(--mantine-font-family)',
              fontSize: '14px',
              lineHeight: 1.6,
            }}
          >
            {summary.summary}
          </Box>
        </Paper>
      </ScrollArea>
    </Box>
  );
};
